import React from "react";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { Table, Modal, Button } from "antd";
import { useProjectState } from "../../../context/stateContext";
import tablesInfoActions from "../../../redux/tablesInfo/actions";
import TableInfoModalContent from "./TableInfoModalContent";
import "./index.css";

const { getBillDetailsModal } = tablesInfoActions;

const ExpandedRowRender = ({ row, i, openedTables, closedTables }) => {
  const {
    showBillDetails,
    setShowBillDetails,
    setOpenTime,
    setCloseTime,
    setOrdersCountTime,
    setDuration,
    setWaiterName,
    setTableName,
    setBillAmount,
    setBillId,
  } = useProjectState();
  const { loading } = useSelector((state) => state.tablesInfoReducer);
  const dispatch = useDispatch();

  let key = 1;
  const data = row?.details.map((z) => ({
    key: key++,
    openTime: z.openTime,
    closeTime: z.closeTime,
    durationInSeconds: z.durationInSeconds,
    tableName: z.tableName,
    waiterName: z.waiterName,
    ordersCount: z.ordersCount,
    billAmount: z.billAmount,
    billId: z.billId,
  }));

  let filteredTables = [];
  if (openedTables && closedTables) {
    filteredTables = data;
  } else if (openedTables && !closedTables) {
    filteredTables = data?.filter((table) => table.closeTime === null);
  } else if (!openedTables && closedTables) {
    filteredTables = data?.filter((table) => table.closeTime !== null);
  }

  let filteredDataSum = 0;
  const customFilter = (value, record) => {
    if (record.waiterName.indexOf(value) === 0) {
      filteredDataSum += record.billAmount;
    }
    return record.waiterName.indexOf(value) === 0;
  };

  const getTotalSum = () => {
    if (filteredDataSum !== 0) return filteredDataSum;
    let turnoverSum = 0;
    if (!filteredTables || filteredTables.length === 0) return 0.0;
    else {
      filteredTables.forEach((element) => {
        turnoverSum += element.billAmount;
      });
      return turnoverSum;
    }
  };

  const tableNameFilterArray = () => {
    return filteredTables
      ?.map((table) => table.tableName)
      ?.filter((value, index, array) => {
        return array.indexOf(value) === index;
      })
      ?.map((name) => {
        return {
          text: name,
          value: name,
        };
      });
  };

  const columns = [
    {
      title: "Открита",
      align: "center",
      sorter: (a, b) => dayjs(a.openTime).unix() - dayjs(b.openTime).unix(),
      key: "openTime",
      width: "10%",
      render: (value) => (
        <div>{dayjs(value.openTime).format("DD.MM - HH:mm")}</div>
      ),
    },
    {
      title: "Закрита",
      align: "center",
      sorter: (a, b) => dayjs(a.closeTime).unix() - dayjs(b.closeTime).unix(),
      key: "closeTime",
      width: "10%",
      render: (value) =>
        value.closeTime !== null ? (
          <div>{dayjs(value.closeTime).format("DD.MM - HH:mm")}</div>
        ) : (
          "-"
        ),
    },
    {
      title: "Маса",
      dataIndex: "tableName",
      sorter: (a, b) => {
        const numericA = parseInt(a.tableName);
        const numericB = parseInt(b.tableName);

        if (!isNaN(numericA) && !isNaN(numericB)) {
          return numericA - numericB;
        } else if (!isNaN(numericA)) {
          return -1;
        } else if (!isNaN(numericB)) {
          return 1;
        } else {
          return a.tableName.localeCompare(b.tableName);
        }
      },
      width: "20%",
      align: "center",
      filters: tableNameFilterArray(),
      filterSearch: true,
      onFilter: (value, record) => record.tableName.startsWith(value),
    },
    {
      title: "Сервитьор",
      dataIndex: "waiterName",
      rowKey: "waiterName",
      align: "center",
      key: "waiterName",
      width: "30%",
      onFilterDropdownOpenChange: () => {
        filteredDataSum = 0;
      },
      onFilter: customFilter,
      filters: (filteredTables || [])
        .filter(
          (a, i) =>
            filteredTables.findIndex((s) => a.waiterName === s.waiterName) === i
        )
        .map((c) => ({ text: c.waiterName, value: c.waiterName })),
      render: (value) => <div>{value}</div>,
    },
    {
      title: () => {
        return (
          <div className="table-info-table-total-column">
            Сума{" "}
            {getTotalSum()
              .toFixed(2)
              .toString()
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
              .replace(",", " ")}
          </div>
        );
      },
      align: "center",
      sorter: (a, b) => a.billAmount - b.billAmount,
      width: "20%",
      key: "billAmount",
      render: (value) => (
        <div>
          {(Math.round(parseFloat(value.billAmount) * 100) / 100).toFixed(2)}
        </div>
      ),
    },
  ];

  const getBillDetails = (record) => {
    dispatch(getBillDetailsModal(record.billId));
    setShowBillDetails(!showBillDetails);
    setOpenTime(record.openTime);
    setCloseTime(record.closeTime);
    setOrdersCountTime(record.ordersCount);
    setDuration(record.durationInSeconds);
    setTableName(record.tableName);
    setWaiterName(record.waiterName);
    setBillAmount(record.billAmount);
    setBillId(record.billId);
  };

  return (
    <>
      <Table
        size="small"
        loading={loading}
        id="table-info-second-table"
        className="tables-info-table"
        columns={columns}
        dataSource={filteredTables}
        pagination={false}
        bordered={true}
        rowClassName={(record) =>
          record.closeTime == null
            ? "table-info-open-table"
            : "table-info-close-table"
        }
        onRow={(record) => {
          return {
            onClick: () => getBillDetails(record),
          };
        }}
      />
      <Modal
        className="table-info-modal"
        centered
        cancelButtonProps={{ style: { display: "none" } }}
        open={showBillDetails}
        bodyStyle={{ height: "auto" }}
        footer={null}
        onCancel={() => setShowBillDetails(!showBillDetails)}
      >
        <TableInfoModalContent />
        <div style={{ textAlign: "center" }}>
          <Button
            type="primary"
            onClick={() => setShowBillDetails(!showBillDetails)}
          >
            Затвори
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default ExpandedRowRender;
